module.exports = __webpack_public_path__ + "static/media/Tejas.eb4d69d3.png";